export default {"src":"/_next/static/media/notification.4cc8e73b.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};